import SettingTypes from '../types/SettingTypes';

const initialState = {
  isLoading: false,
  vairalbleData: [],
  stripeData: [],
  paypalData: [],
  authorizeData: [],
  generalData: [],
  veemData: [],
  cloverData: [],
  boaData: [],
  profileData: {},
  mailVerifyData: true,
  bankListData: [],
  bankItemData: {},
  bankqueryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  },
  officeListData: [],
  officeItemData: {},
  officequeryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  },
  signListData: [],
  signItemData: {},
  signqueryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: ''
  }
};

// eslint-disable-next-line default-param-last
const setting = (state = initialState, action) => {
  switch (action.type) {
    case SettingTypes.GET_SETTING_MAIL_VARIABLE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_SETTING_MAIL_VARIABLE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        vairalbleData: action.payload
      };
    case SettingTypes.GET_SETTING_MAIL_VARIABLE_ERROR:
      return {
        ...state,
        isLoading: false,
        vairalbleData: []
      };
    case SettingTypes.GET_PAYMENT_STRIPE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_STRIPE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        stripeData: action.payload
      };
    case SettingTypes.GET_PAYMENT_STRIPE_ERROR:
      return {
        ...state,
        isLoading: false,
        stripeData: []
      };

    case SettingTypes.GET_PAYMENT_VEEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_VEEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        veemData: action.payload
      };
    case SettingTypes.GET_PAYMENT_VEEM_ERROR:
      return {
        ...state,
        isLoading: false,
        veemData: []
      };

    case SettingTypes.GET_PAYMENT_BANKOFAMERICA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_BANKOFAMERICA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        boaData: action.payload
      };
    case SettingTypes.GET_PAYMENT_BANKOFAMERICA_ERROR:
      return {
        ...state,
        isLoading: false,
        boaData: []
      };

    case SettingTypes.GET_PAYMENT_CLOVER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_CLOVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cloverData: action.payload
      };
    case SettingTypes.GET_PAYMENT_CLOVER_ERROR:
      return {
        ...state,
        isLoading: false,
        cloverData: []
      };

    case SettingTypes.GET_PAYMENT_PAYPAL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_PAYPAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paypalData: action.payload
      };
    case SettingTypes.GET_PAYMENT_PAYPAL_ERROR:
      return {
        ...state,
        isLoading: false,
        paypalData: []
      };

    case SettingTypes.GET_PAYMENT_AUTHORIZENET_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_PAYMENT_AUTHORIZENET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        authorizeData: action.payload
      };
    case SettingTypes.GET_PAYMENT_AUTHORIZENET_ERROR:
      return {
        ...state,
        isLoading: false,
        authorizeData: []
      };
    case SettingTypes.GET_GENERAL_SETTINGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_GENERAL_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        generalData: action.payload
      };
    case SettingTypes.GET_GENERAL_SETTINGS_ERROR:
      return {
        ...state,
        isLoading: false,
        generalData: []
      };
    case SettingTypes.GET_USER_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profileData: action.payload
      };
    case SettingTypes.GET_USER_PROFILE_ERROR:
      return {
        ...state,
        isLoading: false,
        profileData: []
      };
    case SettingTypes.GET_VERIFY_MAIL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_VERIFY_MAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mailVerifyData: true
      };
    case SettingTypes.GET_VERIFY_MAIL_ERROR:
      return {
        ...state,
        isLoading: false,
        mailVerifyData: false
      };
    case SettingTypes.GET_BANK_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_BANK_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bankListData: action.payload
      };
    case SettingTypes.GET_BANK_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        bankListData: []
      };

    case SettingTypes.GET_BANK_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_BANK_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        bankItemData: action.payload
      };
    case SettingTypes.GET_BANK_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        bankItemData: ''
      };
    case SettingTypes.GET_OFFICE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_OFFICE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        officeListData: action.payload
      };
    case SettingTypes.GET_OFFICE_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        officeListData: []
      };
    case SettingTypes.GET_OFFICE_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_OFFICE_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        officeItemData: action.payload
      };
    case SettingTypes.GET_OFFICE_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        officeItemData: ''
      };
    case SettingTypes.GET_SIGNATURE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_SIGNATURE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        signListData: action.payload
      };
    case SettingTypes.GET_SIGNATURE_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        signListData: []
      };
    case SettingTypes.GET_SIGNATURE_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SettingTypes.GET_SIGNATURE_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        signItemData: action.payload
      };
    case SettingTypes.GET_SIGNATURE_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        signItemData: {}
      };
    case SettingTypes.UPDATE_BANK_QUERY_PARAMS:
      return {
        ...state,
        bankqueryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paginationModel,
          sortingData: action.payload.sortInfo,
          keyword: action.payload.keyword,
          department: action.payload.departmentName
        }
      };
    case SettingTypes.UPDATE_OFFICE_QUERY_PARAMS:
      return {
        ...state,
        officequeryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paginationModel,
          sortingData: action.payload.sortInfo,
          keyword: action.payload.keyword,
          department: action.payload.departmentName
        }
      };
    case SettingTypes.UPDATE_SIGNATURE_QUERY_PARAMS:
      return {
        ...state,
        signqueryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paginationModel,
          sortingData: action.payload.sortInfo,
          keyword: action.payload.keyword,
          department: action.payload.departmentName
        }
      };

    default:
      return state;
  }
};
export default setting;
